/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'daily' }, { id: 'few' }, { id: 'weekly' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-wash-frequency"
      progress={60}
      field="hairstyleWomenWashFrequency"
      setter="setHairstyleWomenWashFrequency"
      ns="hairstyleWomenWashFrequency"
      imageName="hairstyleWomenWashFrequency"
      options={OPTIONS}
    />
  );
}

export default Page;
